﻿$.fn.dxCtrlContentSondageReponse = function custom_dxCtrlContentSondageReponse(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagereponse dx-ctrl");
        this.createInstance(new cdxCtrlContentSondageReponse(this, option));
    }
    return this;
}

window.cdxCtrlContentSondageReponse = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dataSondage = null
    function mConstruit() {
        container.empty()
        container.css("border-top", theme.border)
        dataSondage = option.bddCtrl.getObjet("sondage", option.dataSondageReponse.id_sondage).data

        if (option.dataSondageReponse.vue == "0") {
            option.dataSondageReponse.vue = "1"
            option.bddCtrl.getObjet(option.dataSondageReponse).mSaveChamp("vue")
        }

        mRempliBt()

        var dxScroll = $("<div/>").appendTo(container).dxScrollView({}).dxScrollView("instance")
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(dxScroll.content()).dxCtrlSondageConsolide({
            bddCtrl: option.bddCtrl,
            dataSondage: dataSondage,
            dataSondageReponse: option.dataSondageReponse,
        }).dxCtrlContentSondage("instance")
    }

    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-print",
                    txtTooltip: "Imprimer les statistiques du sondage.",
                    onClick: function (e) {
                        var obj = option.bddCtrl.getObjet(dataSondage)
                        var url = obj.objetMetier.mGetUrlLinkPrint(option.dataSondageReponse.id_sondage_reponse)
                        option.bddCtrl.mAjaxCall({
                            command: "printurl",
                            url: url,
                            nom: obj.data.nom
                        }, function (data) {
                            $("<div/>").dxCtrlPdfViewer({
                                urlPdf: data.urlpdf.substring(1)
                            })
                        })
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)
    }

    this.element = function () { return container }

    mConstruit();
}